import { useCallback, useMemo } from 'react';
import {
	useActiveRightSidebarState,
	useRightSidebarController,
} from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/right-sidebar-controller/index.tsx';

// Use this constant to identify the Rovo AI container in Jira
export const JIRA_ISSUE_ROVO_AI_CONTAINER_ID = 'jira-issue-rovo-ai-container';

// Default width for the Rovo AI container in pixels
export const JIRA_ROVO_AI_CONTAINER_WIDTH = 400; // px

export function useSidebarApiObject() {
	const { openRightSidebar, closeRightSidebar, closeCurrentRightSidebar } =
		useRightSidebarController();
	const { panelId, isCollapsed } = useActiveRightSidebarState() || {};

	const isActive = panelId === JIRA_ISSUE_ROVO_AI_CONTAINER_ID && !isCollapsed;
	const isOtherPanelActive = panelId !== JIRA_ISSUE_ROVO_AI_CONTAINER_ID && !isCollapsed;

	const openPanel = useCallback(() => {
		isOtherPanelActive && closeCurrentRightSidebar();
		openRightSidebar(JIRA_ISSUE_ROVO_AI_CONTAINER_ID, JIRA_ROVO_AI_CONTAINER_WIDTH);
	}, [closeCurrentRightSidebar, isOtherPanelActive, openRightSidebar]);

	const closePanel = useCallback(() => {
		closeRightSidebar(JIRA_ISSUE_ROVO_AI_CONTAINER_ID);
	}, [closeRightSidebar]);

	return useMemo(
		() => ({
			isPanelOpen: () => isActive,
			openPanel,
			closePanel,
		}),
		[isActive, openPanel, closePanel],
	);
}
